import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
export class ErrorMessage {
    constructor(category, // Uppercase undescore, e.g. LOGIN_ERROR
    message, // Short summary, e.g. `Http failure response for https://localhost:4200/ws/user/sign/in/google: 400 Bad Request`
    log // Long summary
    ) {
        this.category = category;
        this.message = message;
        this.log = log;
    }
}
export class ErrorService {
    constructor(http) {
        this.http = http;
    }
    logError(error) {
        return this.http.post(`/ws/human-error`, error);
    }
}
ErrorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ErrorService_Factory() { return new ErrorService(i0.ɵɵinject(i1.HttpClient)); }, token: ErrorService, providedIn: "root" });
